import SettingsDashboard from "@/components/settings/SettingsDashboard.vue";
import MassiveSettingsDashboard from "@/components/settings/massive/MassiveSettingsDashboard.vue";

const settingsRoutes = [
  { path: "/settings", name: "settings", component: SettingsDashboard },
  {
    path: "/settings/massive",
    name: "settings-massive",
    component: MassiveSettingsDashboard,
  },
  {
    path: "/role-permissions",
    name: "role-permissions",
    component: () =>
      import(
        /* webpackChunkName: "settings" */ "@/components/settings/RolePermissions.vue"
      ),
  },
  {
    path: "/diagnosis-catalog",
    name: "diagnosis-catalog",
    component: () =>
      import(
        /* webpackChunkName: "settings" */ "@/components/settings/DiagnosisCatalog.vue"
      ),
  },
  {
    path: "/urgency-config",
    name: "urgency-config",
    component: () =>
      import(
        /* webpackChunkName: "settings" */ "@/components/settings/urgencyConfig/UrgencyConfig.vue"
      ),
  },
  {
    path: "/urgency-providers",
    name: "urgency-providers",
    component: () =>
      import(
        /* webpackChunkName: "settings" */ "@/components/settings/urgencyConfig/UrgencyProviders.vue"
      ),
  },
  {
    path: "/urgency-queue",
    name: "urgency-queue",
    component: () =>
      import(
        /* webpackChunkName: "urgency" */ "@/components/settings/urgencyConfig/UrgencyQueue.vue"
      ),
  },
  {
    path: "/urgency-create-case",
    name: "urgency-create-case",
    component: () =>
      import(
        /* webpackChunkName: "urgency" */ "@/components/settings/urgencyConfig/UrgencyCreateCase.vue"
      ),
  },
];

export default settingsRoutes;
